/** Bỏ dấu tiếng Việt để tìm không phân biệt dấu: "Số dư" → "so du". Không dùng để hiển thị. */
export function foldVi(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase()
}
